import { TiptapContentNode } from '../../tiptapTypes';
import { reduceTiptapContent } from './reduceTiptapContent';

/**
 * Determines whether the Tiptap content contains any marks.
 */
const hasAnyTiptapMarks = (tiptapNode?: TiptapContentNode): boolean => {
    if (!tiptapNode) return false;

    return reduceTiptapContent(
        tiptapNode,
        (hasMarks, node) => {
            if (hasMarks) return true;
            return !!node.marks?.length;
        },
        false,
    );
};

export default hasAnyTiptapMarks;
